export default "__VITE_ASSET__4e$a7c91__ 1200w";